import { TableHTMLAttributes } from 'react';
import classnames from 'src/util/classnames';

interface TableProps extends TableHTMLAttributes<HTMLTableElement> {
  responsive?: boolean | string;
  bordered?: boolean;
  borderless?: boolean;
  striped?: boolean | string;
  hover?: boolean;
  size?: 'sm';
  dark?: boolean;
}

export function Table({ responsive, bordered, borderless, striped, hover, size, dark, className, children, ...props }: TableProps) {
  const table = (
    <table
      className={classnames(
        'table',
        bordered && 'table-bordered',
        borderless && 'table-borderless',
        striped === true ? 'table-striped' : typeof striped === 'string' ? `table-striped-${striped}` : undefined,
        hover && 'table-hover',
        size && `table-${size}`,
        dark && 'table-dark',
        className
      )}
      {...props}
    >
      {children}
    </table>
  );

  if (!responsive) return table;

  return <div className={typeof responsive === 'string' ? `table-responsive-${responsive}` : 'table-responsive'}>{table}</div>;
}
